import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "App";
import axiosInstance from "axiosConfig";
import { PACKET_ENUM, TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";

interface ChangePacketParams {
  packet: PACKET_ENUM;
  discountCode?: string;
}

export const useChangePacket = (
  options?: UseMutationOptions<any, Error, ChangePacketParams>
) => {
  return useMutation({
    mutationKey: ["changePacket"],
    mutationFn: async ({ packet, discountCode }: ChangePacketParams) => {
      return axiosInstance
        .put(`users/package`, { package: packet, ...(discountCode && { discountCode }) })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Ładowanie...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "changePacket",
      });

      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Zaktualizowano pakiet",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "changePacket",
      });
      queryClient.prefetchQuery({ queryKey: ["me"] });
      queryClient.invalidateQueries({ queryKey: ["customers"] });
      queryClient.invalidateQueries({ queryKey: ["subscriptions"] });
      queryClient.invalidateQueries({ queryKey: ["paymentMethods"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },

    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas aktualizacji pakietu",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "changePacket",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
